




















































































































































































































































































































































































































































































import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { Patient } from '@/data/models/patient.model';
import { CrudService } from '@/data/services/crud.service';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Veicolo } from '@/data/models/veicolo.model';
import { ClassType } from 'class-transformer/ClassTransformer';

import  Note  from '../attori/note/Note.vue';
import { ListService } from '@/data/services/list.service';
import { Actor } from '@/data/models/actor.model';
import { Search } from '@/data/models/search.model';

@Component({
	components: {
		ValidationProvider,
		ValidationObserver,
		Note
	}
})
export default class PazienteDetail extends Vue{
	@Inject('CrudService') patientCrudService!: CrudService<Patient>;
	@Inject('CrudService') vehicleCrudService!: CrudService<Veicolo>;
	@Inject('ListService') listService!: ListService;

	@Prop() patientid!: number;
	@Prop() actorid!: number;

	patient: Patient = new Patient();
	advancedSearch = new Search('actor');
	advancedSearchDoctor = new Search('actor');
	actorSelected: Actor | null = null;

	doctorSelected: Actor | null = null;
	actorClass: ClassType<Actor> = Actor;

	invoicedefault: boolean = true;

	isConditionsOpen = false;
	types: string[] = [];
	enableEntity: boolean = false;

	constructor() {
		super();
		this.loadTypes();
		this.advancedSearchDoctor.addNotEqualFilter('doctorid', null);
	}

	init() {
		this.patient = new Patient();
		this.doctorSelected = null;
		this.actorSelected = null;
	}

	@Watch('patientid') 
	onPatientChange() {
		if(this.patientid) {
			this.loadPatient();
		}
	}

	loadTypes() {
		this.listService.getListItemsBySlug('patient.type').then((result: any) => {
			this.types = result.data;
		});
	}

	loadPatient() {
		this.patientCrudService.getEntity(Patient, 'patient', this.patientid).then((result: any) => {
			
			if(result) {
				this.patient = result;
				this.invoicedefault = (this.patient.invoiceto === this.actorid);
				if(this.patient.doctor) {
					this.doctorSelected = this.patient.doctor;
				}
				this.enableEntity = true;
			}
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

	onEnableEntityChange(event: any) {
		if(!event && this.patient.id) {
			this.$buefy.dialog.confirm({
				message: this.$t('warning-patient-delete') as string,
				type: 'is-danger',
				hasIcon: true,
				cancelText: this.$t('annulla') as string,
				onConfirm: () => {
					this.patientCrudService
						.deleteEntity(Patient, 'patient', this.patient)
						.then(() => {
							this.init();
							this.$emit('updatePatient', this.patient);
							this.$buefy.notification.open({
								message: '' + this.$t('patient-deleted'),
								type: 'is-success',
							});
						})
						.catch((error) => {
							this.$buefy.notification.open({
								message: error.msg,
								type: 'is-danger',
							});
						});
				}, 
				onCancel: () => {
					this.enableEntity = true;
				}
			});
		}
	}

	submit() {
		this.patient.doctorid = this.doctorSelected ? this.doctorSelected.id : undefined;
		this.patient.invoiceto = !this.invoicedefault && this.patient.payer ? this.patient.payer.id : this.actorid;
		const call = (this.patient!.id) ? 
			this.patientCrudService.saveEntity(Patient, 'patient', this.patient) : 
			this.patientCrudService.createEntity(Patient, 'patient', this.patient);
		call.then(result => {
			this.patient = result;
			this.$emit('updatePatient', this.patient);
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

}
